import * as exElement from '../../../utils/element';

// ----------------------------------------------------------------------------

function createTableBody(config?: Record<string, any>): HTMLTableSectionElement {
    return exElement.create({
        merge: config,
        tag: 'tbody',
    }) as HTMLTableSectionElement;
}

// ----------------------------------------------------------------------------

export default createTableBody;
